/**
 * Centralizes translation keys and helper methods for table loading statuses.
 * This keeps validation table status labels consistent across the frontend.
 */

/**
 * Maps internal table loading states to their translation keys.
 */
export const TABLE_LOADING_STATUS_KEYS = {
	requesting: "Squeeze.Validation.General.TableLoading.Requesting",
	preparing: "Squeeze.Validation.General.TableLoading.Preparing",
	loadingWidths: "Squeeze.Validation.General.TableLoading.LoadingWidths",
	ready: "Squeeze.Validation.General.TableLoading.Ready",
} as const;

/**
 * Valid status keys that can be resolved to localized table loading text.
 */
export type TableLoadingStatusKey = keyof typeof TABLE_LOADING_STATUS_KEYS;

/**
 * Provides localized display text for validation table loading states.
 */
export class TableStatus {

	/**
	 * Returns the localized loading status text for a validation table.
	 */
	public static getValidationTableLoadingStatusText(t: any, key: TableLoadingStatusKey): string {
		return t(TABLE_LOADING_STATUS_KEYS[key]);
	}

}
